import * as angular from 'angular';
import uiRouter from 'angular-ui-router';
import operationTasksComponent from './operation-tasks.component';
import dataTable from 'angular-material-data-table';

const operationTasksModule = angular
  .module('operationTasks', [uiRouter, dataTable])
  .config([
    '$stateProvider',
    $stateProvider => {
      'ngInject';
      $stateProvider.state('operationTasks', {
        url: '/operation-tasks',
        component: 'operationTasks',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      });
    }
  ])
  .component('operationTasks', operationTasksComponent).name;

export default operationTasksModule;
